var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareicn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4995 4.29729L5.49951 6.86872M5.49951 8.79729L11.4995 11.3687M5.49951 7.83301C5.49951 9.07565 4.49215 10.083 3.24951 10.083C2.00687 10.083 0.999512 9.07565 0.999512 7.83301C0.999512 6.59037 2.00687 5.58301 3.24951 5.58301C4.49215 5.58301 5.49951 6.59037 5.49951 7.83301ZM15.9995 3.33301C15.9995 4.57565 14.9922 5.58301 13.7495 5.58301C12.5069 5.58301 11.4995 4.57565 11.4995 3.33301C11.4995 2.09037 12.5069 1.08301 13.7495 1.08301C14.9922 1.08301 15.9995 2.09037 15.9995 3.33301ZM15.9995 12.333C15.9995 13.5756 14.9922 14.583 13.7495 14.583C12.5069 14.583 11.4995 13.5756 11.4995 12.333C11.4995 11.0904 12.5069 10.083 13.7495 10.083C14.9922 10.083 15.9995 11.0904 15.9995 12.333Z",
    stroke: "#272D37",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareicn);
export default __webpack_public_path__ + "static/media/shareicn.6e680b89a872b7ec9b151978e24f111c.svg";
export { ForwardRef as ReactComponent };